module.exports = __webpack_public_path__ + "img/38839-006.ad572a84.jpg";